import rawDoors from '../assets/doors_catalog.json';

export interface DoorCatalogEntry {
  id: string;
  url: string;
  frameWidth: number;
  frameHeight: number;
  frames: number;
  hasLocked: boolean;
  lockedId: string | null;
}

const doors = rawDoors as DoorCatalogEntry[];

export function findDoor(id: string): DoorCatalogEntry | undefined {
  return doors.find((d) => d.id === id);
}

/**
 * Portes proposées dans le mode "Portes" de l'éditeur — uniquement celles
 * dont le sprite s'emboîte dans un mur horizontal de l'éditeur (face de
 * 2 cases, voir computeWallTiles) : haut aligné sur le liseré, bas sur la
 * plinthe. Vérifié par rendu hors ligne le 2026-09-24. Écartées : petites
 * portes door_1..6 (trop basses), portes "verticales" (trait de 4 px,
 * invisible dans une colonne de mur sombre), portes d'immeuble (sprite
 * décentré), WC publics (flotte au-dessus du sol), thèmes hors bureau
 * (prison, morgue, trappes…).
 */
export const DOOR_PALETTE: Array<{ id: string; label: string }> = [
  { id: 'door_big_1', label: 'Porte bois clair' },
  { id: 'door_big_2', label: 'Porte beige' },
  { id: 'door_big_3', label: 'Porte bois rouge' },
  { id: 'door_big_4', label: 'Porte bois clair à hublot' },
  { id: 'door_big_5', label: 'Porte beige à hublot' },
  { id: 'door_big_6', label: 'Porte bois rouge à hublot' },
  { id: 'door_glass_left', label: 'Porte vitrée (poignée à droite)' },
  { id: 'door_glass_right', label: 'Porte vitrée (poignée à gauche)' },
  { id: 'door_glass_double', label: 'Double porte vitrée' },
  { id: 'door_glass_sliding', label: 'Porte vitrée coulissante' },
  { id: 'hospital_glass_door', label: 'Porte vitrée dépolie' },
  { id: 'hospital_door_blue', label: 'Porte bleue' },
  { id: 'hospital_door_green', label: 'Porte verte' },
  { id: 'hospital_door_green_double', label: 'Double porte verte' },
  { id: 'japanese_sliding_door', label: 'Porte coulissante japonaise' },
  { id: 'door_bathroom', label: 'Porte sanitaires' },
  { id: 'elevator_door_entrance_1', label: 'Ascenseur (métal)' },
  { id: 'elevator_door_entrance_2', label: 'Ascenseur (vitré)' },
];
